export default __webpack_public_path__ + "media/collaboration3x.ae0c4683.png";